import { faAlignRight, faClipboardCheck, faShoppingCart, faTrashAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import EventApi from '../../../../Api/EventApi';
import { getResponseError } from '../../../../Api/Utils/apiUtils';
import './ExtraFeaturs.css'

const ExtraFeaturs = ({eventid, seErr}) => {
    const history = useHistory()
    const [isactiveToolpit, setisactiveToolpit] = useState(false);

    const deleteThisEvent = async (event) => {
        const respons = await EventApi.deleteEvent(event)
        const responseApiError = getResponseError(respons)
        if (responseApiError) {
            seErr(responseApiError)
        }else{
            if (respons.success === "true") {
                const loc = {
                    pathname: '/manage-events',
                    state: { id: `` }
                }
                history.push(loc)
                history.replace(loc)
            }
        }
    }
    return (
        <div className='extra-featurs'>
            {isactiveToolpit &&
            <div className="item-toolpit">
                <Link to="/suppliers">
                    <div className="find-supplier">
                        <FontAwesomeIcon icon={faShoppingCart} />
                        <h5>Find Supplier For Event</h5>
                    </div>
                </Link>
                <hr />
                <Link to={`/${eventid}/guest-list`}>
                    <div className="find-supplier">
                        <FontAwesomeIcon icon={faUsers} />
                        <h5>Guest List</h5>
                    </div>
                </Link>
                <hr />
                <Link to={`/${eventid}/to-do`}>
                    <div className="find-supplier">
                        <FontAwesomeIcon icon={faClipboardCheck} />
                        <h5>To Do List</h5>
                    </div>
                </Link>
                <hr />
                <Link to={`/${eventid}/manage-budget`}>
                    <div className="find-supplier">
                        <FontAwesomeIcon icon={faClipboardCheck} />
                        <h5>Manage Budget</h5>
                    </div>
                </Link>
                <hr />
                <div className="find-supplier" onClick={() => deleteThisEvent(eventid)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                    <h5>Delete Event</h5>
                </div>
            </div>}
            <div className="featurs-toggle" onClick={() => setisactiveToolpit(!isactiveToolpit)} style={isactiveToolpit ? {transform: `rotate(45deg)`} : {transform: `rotate(0deg)`}}>
                <FontAwesomeIcon icon={faAlignRight} />
            </div>
        </div>
    )
};

export default ExtraFeaturs;
